import React from 'react';

const Footer = ({ siteData }) => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-sage-800 text-white py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div>
                        <h3 className="text-2xl font-light mb-4">Savana Ashlea</h3>
                        <p className="text-sage-100 leading-relaxed mb-4">
                            Creating beautiful moments through art, photography, and wellness.
                        </p>
                        <div>
                            <a
                                href="https://www.instagram.com/savanashlea/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-sage-100 hover:text-white transition-colors inline-block"
                                aria-label="Instagram"
                            >
                                <i className="bi bi-instagram text-2xl"></i>
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-lg font-medium mb-4">Quick Links</h4>
                        <ul className="space-y-2 text-sage-100">
                            <li><a href="/" className="hover:text-white transition-colors">Home</a></li>
                            <li><a href="/photography" className="hover:text-white transition-colors">Photography</a></li>
                            <li><a href="/yoga" className="hover:text-white transition-colors">Yoga</a></li>
                            <li><a href="/art" className="hover:text-white transition-colors">Art</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-medium mb-4">Contact</h4>
                        <div className="text-sage-100">
                            <p>savanashlea@gmail.com</p>
                        </div>
                    </div>
                </div>

                <div className="border-t border-sage-700 mt-8 pt-8 text-center text-sage-200">
                    <p>&copy; {currentYear} Savana Ashlea. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;